import styled from '@emotion/styled';
import { useGetPortalSummary } from 'api/hooks';
import { ReactComponent as NotFoundSocket } from 'assets/not-found-left-socket.svg';
import { ReactComponent as NotFoundPlug } from 'assets/not-found-right-plug.svg';
import { ReactComponent as NotFoundCard } from 'assets/portal-not-found-card.svg';
import { ServiceError } from 'proto/web_app_grpc_pb_service';
import React from 'react';
import { colors } from 'styles/colors';

const FoFPage = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;

  background: ${colors.januaryGrey};
`;

const MessageBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 600px;
  width: 1040px;
  max-width: 100vw;
  min-width: 600px;

  background: white;
  border-radius: 30px;
  box-shadow: 0 0 99px #0000000d;
  color: ${colors.decemberGrey};

  svg {
    margin-bottom: 64px;
  }
`;

const Title = styled.div`
  font-size: 48px;
  line-height: 58px;
  margin-bottom: 18px;
`;

const ExtraInfo = styled.div`
  font-size: 22px;
  line-height: 26px;
`;

const LinkLikeText = styled.span`
  color: ${colors.offBlue};
`;

const PlugHolder = styled.div`
  position: absolute;
  right: 0;
  bottom: 50%;
  margin-bottom: 85px;
`;

const SocketHolder = styled.div`
  position: absolute;
  top: 50%;
  margin-top: -150px;
  left: -9px; /* Offsets an issue with the SVG */
`;

export function FourOhFour() {
  const { portalSummary, portalSummaryError } = useGetPortalSummary();

  return (
    <FoFPage>
      <MessageBox>
        <NotFoundCard />
        <Title>Portal Not Found!</Title>
        <ExtraInfo data-testid='portal-not-found'>
          {portalSummaryError === undefined || (portalSummaryError as ServiceError | null)?.code === 2 ? (
            <>
              No portal exists for <LinkLikeText>"{window.location.host}"</LinkLikeText>
            </>
          ) : (
            <>Unable to get any information about a portal.</>
          )}
        </ExtraInfo>
      </MessageBox>

      <PlugHolder>
        <NotFoundPlug />
      </PlugHolder>

      <SocketHolder>
        <NotFoundSocket />
      </SocketHolder>
    </FoFPage>
  );
}
